import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "snapshotblendingmodes"
    }}>{`SnapshotBlendingModes`}</h1>
    <p>{`Modes that control which nearby snapshots, by size and shape, are blended into the new layout.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`IGNORE_LAYOUT_SNAPSHOTS`}</strong>{` = 1399736679`}</p>
      <p parentName="blockquote">{`Turns off the influence of layout snapshots completely.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`USE_NEAREST_SNAPSHOT`}</strong>{` = 1399737957`}</p>
      <p parentName="blockquote">{`Use the layout snapshot nearest in size and shape to the new layout.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LIMITED_SNAPSHOT_BLENDING`}</strong>{` = 1399737449`}</p>
      <p parentName="blockquote">{`Use only layout snapshots within the same class as the new layout.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_SNAPSHOT_BLENDING`}</strong>{` = 1399735925`}</p>
      <p parentName="blockquote">{`Use up to three nearest snapshots even if a snapshot is in a different class that the new layout.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      